"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareArguments = exports.ShareOptions = void 0;
exports.ShareOptions = [
    {
        name: "share-operation",
        type: "string",
        description: "Share the agent",
        required: true,
        choices: ["share", "unshare"],
    },
    {
        name: "scope",
        type: "string",
        description: "Share the agent with users",
        default: "users",
        choices: ["tenant", "users"],
    },
    {
        name: "email",
        type: "string",
        description: "Email address of specific users or groups separated by comma.",
    },
];
exports.ShareArguments = [];
//# sourceMappingURL=ShareOptions.js.map